// src/components/StaticMessaging.js
import React from 'react';

const StaticMessaging = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-800 text-white rounded-md shadow-md">
      <h1 className="text-3xl font-bold mb-4">Static Messaging</h1>
      <p className="mb-6">This page allows you to work on static messaging tasks.</p>
      
      <form className="space-y-6">
        {/* Offer Statements */}
        <div>
          <label htmlFor="offerStatements" className="block text-sm font-medium text-gray-300">
            Offer Statements
          </label>
          <textarea
            name="offerStatements"
            id="offerStatements"
            placeholder="Enter your offer statements here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Taglines */}
        <div>
          <label htmlFor="taglines" className="block text-sm font-medium text-gray-300">
            Taglines
          </label>
          <textarea
            name="taglines"
            id="taglines"
            placeholder="Enter your taglines here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* FAQ */}
        <div>
          <label htmlFor="faq" className="block text-sm font-medium text-gray-300">
            FAQ
          </label>
          <textarea
            name="faq"
            id="faq"
            placeholder="Enter your FAQs here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Press Release */}
        <div>
          <label htmlFor="pressRelease" className="block text-sm font-medium text-gray-300">
            Press Release
          </label>
          <textarea
            name="pressRelease"
            id="pressRelease"
            placeholder="Enter your press release here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* Social Bios */}
        <div>
          <label htmlFor="socialBios" className="block text-sm font-medium text-gray-300">
            Social Bios (Instagram, Facebook, Twitter, TikTok, Pinterest)
          </label>
          <textarea
            name="socialBios"
            id="socialBios"
            placeholder="Enter your social bios here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        {/* About Us */}
        <div>
          <label htmlFor="aboutUs" className="block text-sm font-medium text-gray-300">
            About Us
          </label>
          <textarea
            name="aboutUs"
            id="aboutUs"
            placeholder="Enter your about us text here"
            rows="4"
            className="mt-1 block w-full p-2 rounded-md border border-gray-300 bg-gray-100 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>

        <button
          type="submit"
          className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-500 rounded-md font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-600"
        >
          Save Messaging
        </button>
      </form>
    </div>
  );
};

export default StaticMessaging;
